import { defaultStoreUtils } from '@databases/redux';
import { addChangeToDraft } from '@databases/redux/changesets/actions';
import { DatabaseChangeType } from '@databases/types/redux';

interface DeleteCommentProps {
  contentId: string;
  entryId: string;
  fieldId: string;
  threadId: string;
  externalId: string;
  commentCount: number;
  handleClose: () => void;
}

export const useDeleteComment = () => {
  const dispatch = defaultStoreUtils.useDispatch();

  const deleteComment = ({
    contentId,
    entryId,
    fieldId,
    threadId,
    externalId,
    commentCount,
    handleClose,
  }: DeleteCommentProps) => {
    dispatch(
      addChangeToDraft(contentId, {
        type: DatabaseChangeType.DECREMENT_VALUE_COMMENT_THREAD_COMMENT_COUNT,
        entryId,
        fieldId,
        threadId,
      })
    );

    // deleting head of thread - delete option only present in head if length === 1
    if (commentCount === 1) {
      dispatch(
        addChangeToDraft(contentId, {
          type: DatabaseChangeType.REMOVE_VALUE_COMMENT_THREAD,
          entryId,
          fieldId,
          threadId: externalId,
        })
      );

      handleClose();
    }

    dispatch(
      addChangeToDraft(contentId, {
        type: DatabaseChangeType.INCREMENT_VALUE_COMMENT_THREAD_VERSION_NUMBER,
        entryId,
        fieldId,
        threadId,
      })
    );
  };

  return { deleteComment };
};
